<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3">
            <smallBar :user="user"></smallBar>
          </div>
          <div class="col-md-9">
            <div class="material-table-widget dashboard_top_bar">
              <button v-if="company.user_permission=='admin'" class="btn btn-default btn-new v-team-step-0-3" id="show-modal" @click="CreateEmployeeModal = true"><i class="fa fa-plus"></i>&nbsp;新增人員</button>
              <!-- 先將此處隱藏，之後在修正與使用 -->
              <div class="j-forms inline-block pull-right" v-if="1==2">
                <label class="radio-toggle">
                  <input type="checkbox" v-model="company.deal_require_permission" v-on:change="update_deal_require_permission">
                  <i></i>
                  <span class="white-word">只有主管可以看到所有人的交易，分析，與代辦事項。</span>
                </label>
              </div>
              <!-- 隱藏結束 -->
            </div>
            <div class="widget-wrap">
              <div class="widget-header block-header margin-bottom-0 clearfix">
                <div class="pull-left">
                  <h3>{{company.name}}</h3>
                </div>
                <div class="pull-right">
                  <h5 class="text-gray pointer" @click="adminIntroModal = true"><small>主管權限？</small></h5>
                </div>
              </div>
              <table class="table v-team-step-0-2 table-striped table-middle">
                <thead>
                  <tr>
                    <th>人員</th>
                    <th>職稱</th>
                    <th>Email</th>
                    <th>每月業績目標</th>
                    <th>用戶到期日</th>
                    <th>權限</th>
                    <th v-if="company.user_permission=='admin'"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="employee in company.employees" align="left">
                    <td><img class="avatar-size" v-bind:src="employee.user_profile_pic || '/static/avatar-default.jpg'">{{employee.name}}</td>
                    <td>{{employee.title}}</td>
                    <td>{{employee.email}}</td>
                    <td class="pointer" v-if="employee.sales_target == 0 || employee.sales_target == null" @click="editNewTarget(employee)">無每月目標</td>
                    <td class="pointer" @click="checkEmployeeSalesTargets(employee)" v-if="employee.sales_target != 0 && employee.sales_target != null">{{employee.sales_target.toLocaleString()}} <i class="fa fa-cog"></i></td>
                    <td v-if="employee.permission=='admin'">主管
                    </td>
                    <td v-if="employee.permission=='general'">一般
                    </td>
                    <td>{{employee.expired_at}}</td>
                    <td v-if="company.user_permission=='admin'">
                      <a class="row-edit" @click="UpdateEmployeeModal = true;update_employee=employee;employee_permission_cache=employee.permission"><span class="zmdi zmdi-edit"></span></a>
                      <a class="row-edit" @click="destroyEployee(employee)"><span class="fa fa-trash"></span></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
    <!--Page Container End Here-->
    <!-- modal template start-->
    <div v-if="CreateEmployeeModal" @keyup.esc="CreateEmployeeModal = false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="CreateEmployeeModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header">
                <h3 class="text-center">新增工作夥伴</h3>
              </div>
              <a class="btn-close" @click="CreateEmployeeModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body">
              <p class="alert alert-info">邀請你的夥伴進入你的團隊，跟你一起工作！</p>
              <p>1. 請你的夥伴，建立一個新帳號，同時他將擁有30天免費體驗！</p>
              <p>2. 在下方輸入夥伴Email，送出邀請網址</p>
              <p>3. 請夥伴到信箱、收取團隊邀請，即可加入團隊囉！</p>
              <div name="body">
                <div class="input login-input">
                  <input class="form-control login-frm-input" type="text" placeholder="Email" name="email" v-model="email" v-validate="'required|email'">
                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                  <span v-show="errors.has('email')" class="help is-danger">請輸入正確Email格式</span>
              
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="validateBeforeSubmit">
                  新增
                </button>
                <button class="btn btn-primary" @click="CreateEmployeeModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="uploadLogoModal" @keyup.esc="uploadLogoModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="uploadLogoModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                上傳新的LOGO
              </div>
              <a href="#" class="btn-close" @click="uploadLogoModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div class="form-group">
                <dropzone 
                  id="myVueDropzone" 
                  :url="axios.defaults.baseURL + '/settings/update_company'" 
                  :headers=auth_token
                  :maxFileSizeInMB='12'
                  @vdropzone-success="vsuccess"
                  >
                </dropzone>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-default" @click="uploadLogoModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="UpdateEmployeeModal" @keyup.esc="UpdateEmployeeModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="UpdateEmployeeModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header text-center">
              <h4 class="text-center col-12">
                更新夥伴資料
              </h4>
            </div>
            <div class="modal-body">
              <div name="body">
                <div class="text-left">
                  <div class="form-group">
                    <label class="control-label">夥伴名稱</label> 
                    <input class="form-control" type="text" v-model="update_employee.name">
                  </div>
                  <div class="form-group">
                    <label class="control-label">Email</label> 
                    <input class="form-control" type="text" v-model="update_employee.email" disabled="">
                  </div>
                  <div class="form-group">
                    <label class="control-label">職稱</label> 
                    <input class="form-control" type="text" v-model="update_employee.title" placeholder="職稱">
                  </div>
                  <div class="form-group">
                    <label class="control-label">預設的每月業績</label> 
                    <input class="form-control" type="number" v-model="update_employee.sales_target" placeholder="業績目標" name="sales_target" >
                  </div>
                  <div class="form-group">
                    <label class="control-label">團隊權限（主管將可以編輯所有人的各種資料）</label> 
                    <select v-model="employee_permission_cache" class="form-control">
                      <option value="admin">主管</option>
                      <option value="general">一般</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="UpdateEmployee(update_employee)">
                  更新
                </button>
                <button class="btn btn-default" @click="UpdateEmployeeModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="UpdateSalesTargetModal" @keyup.esc="UpdateSalesTargetModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="UpdateSalesTargetModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header text-center">
              <h4 class="text-center col-12">
                {{checked_employee.name}}的 {{ new Date() | moment("YYYY") }} 業績目標
              </h4>
            </div>
            <div class="modal-body scroll">
              <div name="body">
                <div class="input login-input">
                  <h5>目標：${{totalTarget.toLocaleString()}} , 達成：${{totalAmount.toLocaleString()}} , 達成率：{{parseInt(totalAmount*100/totalTarget)}}%</h5>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th class="text-center">月份</th>
                        <th class="text-center">達成件數</th>
                        <th class="text-center">達成金額/目標</th>
                        <th class="text-center">月達成率</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="target in filterTargets" v-bind:class="{ 'table-success': thisMonth(target)}">
                        <td>{{target.month}}</td>
                        <td>{{target.deal_number}}</td>
                        <td>
                          <span v-if="target_edit=='no' || target_edit!=('target_value'+target.id)" @click="editTextClick(('target_value'+target.id),target)">${{target.deal_amount.toLocaleString()}} / ${{target.target.toLocaleString()}} <i class="fa fa-pen"></i></span>
                          <input type="number" v-bind:ref="('target_value'+target.id)" class="form-control" v-if="target_edit==('target_value'+target.id)" v-model="temp_target" @keypress="isNumber($event)" @keydown.enter="$event.target.blur()" v-on:blur="saveTarget(target)">
                        </td>
                        <td>
                          <span v-if="target.target!=0">{{parseInt(target.deal_amount*100 / target.target) }}%</span>
                          <span v-else>-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="UpdateSalesTargetModal = false">
                  關閉
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="adminIntroModal" @keyup.esc="adminIntroModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="adminIntroModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header text-center">
              <h4 class="text-center col-12">
                主管權限 vs 一般權限
              </h4>
            </div>
            <div class="modal-body">
              <div name="body">
                <table class="table table-bordered">
                  <tr>
                    <th></th>
                    <th class="text-center">主管權限</th>
                    <th class="text-center">一般權限</th>
                  </tr>
                  <tr>
                    <td>成員設定</td>
                    <td><i class="fas fa-check"></i></td>
                    <td>僅能瀏覽<br>無法邀請與變更</td>
                  </tr>
                  <tr>
                    <td>任務設定</td>
                    <td><i class="fas fa-check"></i></td>
                    <td><i class="fas fa-check"></i></td>
                  </tr>
                  <tr>
                    <td>公司設定</td>
                    <td><i class="fas fa-check"></i></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>階段設定</td>
                    <td><i class="fas fa-check"></i></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>付款設定</td>
                    <td><i class="fas fa-check"></i></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>帳單一覽</td>
                    <td><i class="fas fa-check"></i></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="width:40%">變更瀏覽權限<br>(所有成員可以看到彼此訂單，或是只能看到自己)</td>
                    <td style="width:30%"><i class="fas fa-check"></i></td>
                    <td style="width:30%"></td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="adminIntroModal = false">
                  關閉
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import smallBar from './SmallBar.vue';
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import Dropzone from 'vue2-dropzone'

export default {
  name: 'company',
  components: { Simplert,Dropzone,smallBar },
  data() {
    return {
      company: '',
      CreateEmployeeModal: false,
      UpdateEmployeeModal: false,
      UpdateSalesTargetModal: false,
      uploadLogoModal: false,
      cards: '',
      email: '',
      permission: '',
      refs: this.$refs,
      update_employee: {},
      employee_permission_cache: '',
      auth_token: '',
      target_year: (new Date().getFullYear()).toString(),
      checked_employee: {},
      target_edit: 'no',
      temp_target: 0,
      adminIntroModal: false,
    }
  },
  created() {
    this.getCompany()
  },
  computed: {
    filterTargets: function () {
      var result = []
      if(this.checked_employee.sales_targets){
        result = this.checked_employee.sales_targets.filter(target => target.year == parseInt(this.target_year))
        result = result.sort( ( a, b) => {
          return a.month - b.month;
        });
      }
      return result
    },
    totalTarget: function () {
      var result = 0
      if(this.filterTargets.length>0){
        result = this.filterTargets.reduce((acc, item) => acc + item.target, 0);
      }
      return result
    },
    totalAmount: function () {
      var result = 0
      if(this.filterTargets.length>0){
        result = this.filterTargets.reduce((acc, item) => acc + item.deal_amount, 0);
      }
      return result
    },
  },
  props: ['toggle_aside','user'],
  methods: {
    getCompany() {
      // defiine vm to assign this (assign vue data) because in axios there is other this
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('settings/get_company').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.company = response['data']['data']['company']
            vm.getCard();
          } else {
            console.log('Error')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    thisMonth(target){
      var nowYear = (new Date().getFullYear()).toString()
      var nowMonth = (new Date().getMonth()+1).toString()
      if(target.year.toString() == nowYear && target.month.toString() == nowMonth ){
        return true
      }else{
        return false
      }
    },
    editNewTarget(employee){
      if(this.company.user_permission=='admin' || employee.id == this.company.user_id){
        this.UpdateEmployeeModal = true
        this.update_employee=employee
        this.employee_permission_cache=employee.permission
      }
    },
    getCard() {
      // defiine vm to assign this (assign vue data) because in axios there is other this
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('users/get_card').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.cards = response['data']['data']
          } else {
            console.log('Error card')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    getCardIcon(card) {
      return {
        'fab fa-cc-visa': card.card_type == "visa"
      }
    },
    updateCompany() {
      var vm = this
      this.axios.post('settings/update_company', {
        company: vm.company
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          var obj = {
            isShown: true,
            title: '更新成功',
            type: 'success',
            hideAllButton: true
          }
          vm.refs.simplert.openSimplert(obj);
        } else if (response['data']['status'] == 'fail') {
          var obj = {
            isShown: true,
            title: '更新失敗、請稍後再試',
            message: '更新失敗',
            type: 'error',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    saveTarget(target){
      let vm = this
      this.target_edit='no'
      target.target = parseInt(this.temp_target||0)
      this.axios.post('users/update_single_target', {
        target: target
      })
      .then(function(response) {
        if (response.status == 200) {

        } else {
          toastr.danger('更新失敗，請再試一次，或稍後再試')
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    editTextClick(n,target){
      var vm = this
      this.target_edit = n
      this.temp_target = target.target
      this.$nextTick(() => {
        if (Array.isArray(vm.$refs[n])){
          vm.$refs[n][0].focus()
        }else{
          vm.$refs[n].focus()
        }
      })
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    checkEmployeeSalesTargets(employee){
      if(this.company.user_permission=='admin' || employee.id == this.company.user_id){
        let vm = this
        this.checked_employee = employee
        this.UpdateSalesTargetModal = true
      }
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.CreateEmployee();
        } else {
          console.log('fails')
        }
      });
    },
    vsuccess(file, response) {
      this.company.logo = response["data"]
      this.uploadLogoModal = false
      var obj = {
        isShown: true,
        title: '更新成功',
        type: 'success',
        hideAllButton: true
      }
      this.$refs.simplert.openSimplert(obj);
    },
    CreateEmployee() {
      const vm = this;
      this.axios.post('settings/invite_employee', {
          user: {
            email: vm.email,
            permission: vm.permission,
          }
        })
        .then(function(response) {
          if (response['data']['status'] == 'success') {
            vm.CreateEmployeeModal = false
            var obj = {
              isShown: true,
              title: '已發送邀請信',
              message: '已發送邀請信至'+ vm.email +',請該成員前往收信，點擊『加入團隊』按鈕，就可加入你的團隊囉',
              type: 'success',
              customCloseBtnText: '關閉'
            }
            vm.refs.simplert.openSimplert(obj);
            vm.email = ""
            vm.permission = ""
          } else if (response['data']['status'] == 'fail') {
            if(response['data']['msg'] == '001'){
              var obj = {
                isShown: true,
                title: '新增人員失敗',
                message: '你自己已經在裡面啦，邀請你自己幹嘛～？',
                type: 'error',
                customCloseBtnText: '關閉'
              }
            }else{
              var obj = {
                isShown: true,
                title: '新增人員失敗',
                message: 'Email尚未註冊，先請你的夥伴註冊一個帳號，再輸入夥伴的Email，送出邀請信',
                type: 'error',
                customCloseBtnText: '關閉'
              }
            }
            vm.refs.simplert.openSimplert(obj);
            vm.CreateEmployeeModal = false
            vm.email = ""
            vm.permission = ""
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    UpdateEmployee(update_employee) {
      // assign the cached employee permission to employee will be update
      update_employee.permission = this.employee_permission_cache
      const vm = this;
      this.axios.put('settings/update_employee', {
          user: update_employee
        })
        .then(function(response) {
          if (response['data']['status'] == 'success') {
            vm.UpdateEmployeeModal = false
            console.log(update_employee,response['data']['data']['employee']['sales_targets'])
            update_employee.sales_targets = response['data']['data']['employee']['sales_targets']

            //如果有更新到業績目標，跳出提醒，並更新
            // if (update_employee.sales_target != update_employee.sales_target_now.target) {
            //   vm.UpdateSalesTargetModal = true;
            // }
          } else if (response['data']['status'] == 'fail') {
            var obj = {
              isShown: true,
              title: '更新人員失敗',
              message: '更新失敗',
              type: 'error',
              customCloseBtnText: '關閉'
            }
            vm.refs.simplert.openSimplert(obj);
            vm.UpdateEmployeeModal = false
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    UpdateSalesTarget(sales_target_id){
      var vm = this
      console.log(sales_target_id)
      this.axios.put('settings/sync_sales_target', {
          id: sales_target_id
        })
        .then(function(response) {
          if (response['data']['status'] == 'success') {
            vm.UpdateSalesTargetModal = false
          } else if (response['data']['status'] == 'fail') {
            var obj = {
              isShown: true,
              title: '更新業績失敗',
              message: '更新失敗',
              type: 'error',
              customCloseBtnText: '關閉'
            }
            vm.refs.simplert.openSimplert(obj);
            vm.UpdateSalesTargetModal = false
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    destroyEployee(employee){
      const vm = this;
      this.axios.delete('settings/destroy_employee',
       {
          params: {
            user: employee
          }
        })
        .then(function(response) {
          if (response['data']['status'] == 'success') {
            var index = vm.company.employees.indexOf(employee)
            vm.company.employees.splice(index, 1)
          } else if (response['data']['status'] == 'fail') {
            var obj = {
              isShown: true,
              title: '刪除人員失敗',
              message: '人員不存在',
              type: 'error',
              customCloseBtnText: '關閉'
            }
            vm.refs.simplert.openSimplert(obj);
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });

    },
    update_deal_require_permission() {
      const vm = this;
      this.axios.put('settings/update_deal_require_permission', {
          company: {
            deal_require_permission: vm.company.deal_require_permission
          }
        })
        .then(function(response) {
          if (response['data']['status'] == 'success') {

          } else if (response['data']['status'] == 'fail') {
            vm.$toastr.e["更換有問題，請檢察網路狀況，或稍後再試"]
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
  },
}
</script>


// WEBPACK FOOTER //
// Members.vue?6016d666